import {
  // Button,
  TextField,
  // Dialog,
  // DialogTitle,
  // DialogContent,
  // DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  // Typography,
} from "@mui/material";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  Chip,
  Divider,
  Avatar,
  Grid,
  CircularProgress,
  IconButton,
} from "@mui/material";

import {
  Search as SearchIcon,
  Clear as ClearIcon,
  FilterList as FilterIcon,
  // Business as BusinessIcon
} from "@mui/icons-material";
import {
  Close as CloseIcon,
  Assignment as AssignmentIcon,
  Person as PersonIcon,
  CalendarToday as CalendarIcon,
  LocalShipping as ShippingIcon,
  AttachMoney as MoneyIcon,
  Palette as PaletteIcon,
  Inventory as InventoryIcon,
  Business as BusinessIcon,
  Info as InfoIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Image as ImageIcon,
} from "@mui/icons-material";
import { useParams, useHistory } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import InstanceLeftSidebar from "../../InstanceLeftSidebar";
import PageHeaderWithBreadcrumbs from "../../../../components/PageHeaderWithBreadcrumbs";

import "./EliteProduction.css";

// components/ProductionTable.jsx
import React, { useEffect, useState, useContext, useMemo } from "react";
import axios from "axios";
import { AuthContext } from "../../../../helpers/AuthContext";
import DataTable from "../../../../components/DataTable";
import { width } from "@mui/system";

const ProductionTable = ({ department }) => {
  const { authState } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [sites, setSites] = useState([]);
  const [cards, setCards] = useState([]);
  const [searchInput, setSearchInput] = useState("");

  // Modal states
  const [modalOpen, setModalOpen] = useState(false);
  const [modalCard, setModalCard] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);

  // const columns = [
  //   { field: "order_number", headerName: "Order Number", width: 120 },
  //   { field: "customer_name", headerName: "Customer", width: 150 },
  //   { field: "sku", headerName: "SKU", width: 110 },
  //   { field: "product_name", headerName: "Product Name", width: 200 },
  //   { field: "decoration_type", headerName: "Decoration Type", width: 180 },
  //   { field: "location", headerName: "Decoration Location", width: 180 },
  //   { field: "quantity", headerName: "Quantity", width: 100 },
  //   { field: "in_hands_date", headerName: "In Hands Date", width: 150 },
  //   { field: "charge_id", headerName: "Charge ID", width: 100 },
  //   { field: "decoration_id", headerName: "Decoration ID", width: 120 },
  // ];

  // // Function to open card details (reuse from kanban)
  // const openCard = (card) => {
  //   console.log("Opening card with external_key:", card.external_key);
  //   // Use same logic as your kanban openCard function
  //   setModalCard(card);
  //   setModalOpen(true);
  // };

  //  Function to fetch order details from API
  const fetchOrderDetails = async (externalKey) => {
    try {
      setDetailsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/production/order-details?external_key=${externalKey}`
      );
      const json = await response.json();

      console.log("Order details response:", json);

      if (json.success) {
        setOrderDetails(json);
      } else {
        console.error("Failed to fetch order details:", json);
        setOrderDetails(null);
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
      setOrderDetails(null);
    } finally {
      setDetailsLoading(false);
    }
  };

  //  Function to open card details
  const openCard = async (card) => {
    console.log("Opening card with external_key:", card.external_key);
    setModalCard(card);
    setModalOpen(true);

    // Fetch detailed order information
    if (card.external_key) {
      await fetchOrderDetails(card.external_key);
    }
  };

  const columns = [
    { field: "projectNumber", headerName: "Order Number", width: 100 },
    { field: "projectName", headerName: "Product Name", width: 100 },
    { field: "skuNumber", headerName: "SKU", width: 120 },
    // { field: "department", headerName: "Department", width: 130 },
    { field: "processName", headerName: "Process", width: 150 },
    { field: "qtyRequired", headerName: "Quantity", width: 100 },
    { field: "orderProductionState", headerName: "Status", width: 130 },
    {
      field: "orderStatus",
      headerName: "Order Status",
      width: 180,
      renderCell: (params) => (
        <div style={{ fontSize: "12px", lineHeight: "1.3" }}>
          <div
            style={{
              fontWeight: "bold",
              color: "#2563eb",
              marginBottom: "2px",
            }}
          >
            SO: {params.row.salesOrderStatus || "N/A"}
          </div>
          <div style={{ fontWeight: "bold", color: "#dc2626" }}>
            PO: {params.row.purchaseOrderStatus || "N/A"}
          </div>
        </div>
      ),
    },

    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      renderCell: (params) => (
        <button
          onClick={(e) => {
            e.stopPropagation(); // Prevent row click
            openCard(params.row);
          }}
          style={{
            backgroundColor: "#3b82f6",
            color: "white",
            border: "none",
            borderRadius: "6px",
            padding: "4px 8px",
            fontSize: "12px",
            cursor: "pointer",
            fontWeight: "500",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#2563eb")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#3b82f6")}
        >
          Open
        </button>
      ),
    },
    // { field: "salesOrderStatus", headerName: "Order Status", width: 150 },
    // { field: "matrixChargeId", headerName: "Charge ID", width: 100 },
    // { field: "decorationId", headerName: "Decoration ID", width: 120 },
    // { field: "external_key", headerName: "External Key", width: 150 },
  ];

  useEffect(() => {
    const fetchCards = async () => {
      try {
        setLoading(true);

        // Build URL with department filter from props
        let apiUrl = `${process.env.REACT_APP_NODEJS_SERVER_URL}/production/cards`;
        if (department) {
          apiUrl += `?department=${encodeURIComponent(department)}`;
        }

        const res = await fetch(apiUrl);
        const json = await res.json();

        console.log("Cards API Response:", json);

        if (json.success && Array.isArray(json.data)) {
          // Map the cards data to match your table structure
          const mappedData = json.data.map((card, index) => ({
            id: card.external_key || `card-${index}`, // Use external_key as unique ID
            projectNumber: card.projectNumber || "",
            projectName: card.projectName || "",
            skuNumber: card.skuNumber || "",
            department: card.department || "",
            processName: card.processName || "",
            qtyRequired: card.qtyRequired || 0,
            orderProductionState: card.orderProductionState || "",
            salesOrderStatus: card.salesOrderStatus || "",
            matrixChargeId: card.matrixChargeId || "",
            decorationId: card.decorationId || "",
            external_key: card.external_key || "",
            matrixLabel: card.matrixLabel || "",
            stepNumberMajor: card.stepNumberMajor || "",
            stepNumberMinor: card.stepNumberMinor || "",
            activeForProduction: card.activeForProduction,
            stopSignal: card.stopSignal,
            stopLabel: card.stopLabel,
            orderDbId: card.orderDbId,
            itemId: card.itemId,
          }));

          setCards(mappedData);
        }
      } catch (error) {
        console.error("Error fetching cards:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCards();
  }, [department]); // ✅ Refetch when department prop changes

  // Filter cards based on search input
  // const filteredCards = searchInput
  //   ? cards.filter(
  //       (card) =>
  //         card.projectNumber
  //           ?.toLowerCase()
  //           .includes(searchInput.toLowerCase()) ||
  //         card.projectName?.toLowerCase().includes(searchInput.toLowerCase()) ||
  //         card.skuNumber?.toLowerCase().includes(searchInput.toLowerCase()) ||
  //         card.department?.toLowerCase().includes(searchInput.toLowerCase())
  //     )
  //   : cards;



  

  const totalColumnWidth = columns.reduce(
    (sum, col) => sum + (col.width || 100),
    0
  );

  console.log(totalColumnWidth);

  //   return (
  //     <div
  //       style={{
  //         border: "1px solid #ddd",
  //         padding: "10px",
  //         borderRadius: "6px",
  //         width: "100%",
  //         height: "500px",
  //         overflowX: "auto", // Enable horizontal scroll
  //         overflowY: "auto", // Enable vertical scroll
  //       }}
  //     >
  //       {loading ? (
  //         <div>Loading sites...</div>
  //       ) : (
  //         <div style={{ minWidth: `${totalColumnWidth}px` }}>
  //           <DataTable
  //             columns={columns}
  //             rows={filteredSites}
  //             className="production-table"
  //           />
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  // export default ProductionTable;

  //  Order Details Modal Component
  const OrderDetailsModal = () => {
    if (!modalCard) return null;

    const order = orderDetails?.data?.[0];
    const meta = orderDetails?.meta;

    return (
      <Dialog
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setModalCard(null);
          setOrderDetails(null);
        }}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 2, maxHeight: "90vh" },
        }}
      >
        {/* Simple Header */}
        <DialogTitle
          sx={{
            bgcolor: "#f8fafc",
            borderBottom: "1px solid #e2e8f0",
            py: 3,
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography variant="h5" fontWeight="600" color="#1e293b">
                Order #{modalCard.projectNumber}
              </Typography>
              <Typography variant="body2" color="#64748b" mt={0.5}>
                {modalCard.external_key}
              </Typography>
            </Box>
            <IconButton
              onClick={() => {
                setModalOpen(false);
                setModalCard(null);
                setOrderDetails(null);
              }}
              sx={{ color: "#64748b" }}
              size="large">
              ✕
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          {detailsLoading ? (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              py={6}
            >
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  border: "3px solid #e2e8f0",
                  borderTop: "3px solid #3b82f6",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                  "@keyframes spin": {
                    "0%": { transform: "rotate(0deg)" },
                    "100%": { transform: "rotate(360deg)" },
                  },
                }}
              />
              <Typography variant="body1" color="#64748b" mt={2}>
                Loading order details...
              </Typography>
            </Box>
          ) : orderDetails && order ? (
            <Box sx={{ p: 3 }}>
              {/* Order Information */}
              <Box sx={{ mb: 4 }}>
                <Typography
                  variant="h6"
                  fontWeight="600"
                  color="#1e293b"
                  mb={2}
                >
                  Order Information
                </Typography>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                    gap: 3,
                    p: 3,
                    bgcolor: "#f8fafc",
                    borderRadius: 2,
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <Box>
                    <Typography variant="body2" color="#64748b" mb={0.5}>
                      Project Name
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="500"
                      color="#1e293b"
                    >
                      {order.ProjectName || modalCard.projectName}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="body2" color="#64748b" mb={0.5}>
                      Order Number
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="500"
                      color="#1e293b"
                    >
                      {meta?.orderNumber || modalCard.projectNumber}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="body2" color="#64748b" mb={0.5}>
                      Customer
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="500"
                      color="#1e293b"
                    >
                      {order.CustomerName || "Not Assigned"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="body2" color="#64748b" mb={0.5}>
                      External Key
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="500"
                      color="#1e293b"
                      sx={{ fontFamily: "monospace" }}
                    >
                      {modalCard.external_key}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="body2" color="#64748b" mb={0.5}>
                      In Hands Date
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="500"
                      color="#1e293b"
                    >
                      {order.inHandsDate
                        ? new Date(order.inHandsDate).toLocaleDateString()
                        : "Not Set"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="body2" color="#64748b" mb={0.5}>
                      Created Date
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="500"
                      color="#1e293b"
                    >
                      {order.createdAt
                        ? new Date(order.createdAt).toLocaleDateString()
                        : "Unknown"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="body2" color="#64748b" mb={0.5}>
                      Sales Order Status
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="500"
                      color={order.OrderStatus?.SO ? "#059669" : "#64748b"}
                      sx={{
                        px: 2,
                        py: 0.5,
                        bgcolor: order.OrderStatus?.SO ? "#ecfdf5" : "#f1f5f9",
                        borderRadius: 1,
                        display: "inline-block",
                      }}
                    >
                      {order.OrderStatus?.SO ||
                        modalCard.salesOrderStatus ||
                        "N/A"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="body2" color="#64748b" mb={0.5}>
                      Purchase Order Status
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="500"
                      color={order.OrderStatus?.PO ? "#059669" : "#dc2626"}
                      sx={{
                        px: 2,
                        py: 0.5,
                        bgcolor: order.OrderStatus?.PO ? "#ecfdf5" : "#fef2f2",
                        borderRadius: 1,
                        display: "inline-block",
                      }}
                    >
                      {order.OrderStatus?.PO || "Not Available"}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Production Information */}
              <Box sx={{ mb: 4 }}>
                <Typography
                  variant="h6"
                  fontWeight="600"
                  color="#1e293b"
                  mb={2}
                >
                  Production Details
                </Typography>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                    gap: 3,
                    p: 3,
                    bgcolor: "#f8fafc",
                    borderRadius: 2,
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <Box>
                    <Typography variant="body2" color="#64748b" mb={0.5}>
                      Department
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="500"
                      color="#1e293b"
                    >
                      {modalCard.department || "Not Assigned"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="body2" color="#64748b" mb={0.5}>
                      Process Name
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="500"
                      color="#1e293b"
                    >
                      {modalCard.processName || "Not Assigned"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="body2" color="#64748b" mb={0.5}>
                      Production Status
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="500"
                      color="#1e293b"
                      sx={{
                        px: 2,
                        py: 0.5,
                        bgcolor: "#f1f5f9",
                        borderRadius: 1,
                        display: "inline-block",
                      }}
                    >
                      {modalCard.orderProductionState || "Unknown"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="body2" color="#64748b" mb={0.5}>
                      Active for Production
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="500"
                      color="#1e293b"
                    >
                      {meta?.activeForProduction ? "Yes" : "No"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="body2" color="#64748b" mb={0.5}>
                      Stop Signal
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="500"
                      color={meta?.stopSignal ? "#dc2626" : "#059669"}
                    >
                      {meta?.stopSignal ? "Active" : "None"}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="body2" color="#64748b" mb={0.5}>
                      Stop Label
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="500"
                      color="#1e293b"
                    >
                      {meta?.stopLabel || "None"}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Items Section */}
              {order.Items && order.Items.length > 0 && (
                <Box>
                  <Typography
                    variant="h6"
                    fontWeight="600"
                    color="#1e293b"
                    mb={2}
                  >
                    Items ({order.Items.length})
                  </Typography>

                  {order.Items.map((item, index) => (
                    <Box
                      key={item.id || index}
                      sx={{
                        border: "1px solid #e2e8f0",
                        borderRadius: 2,
                        mb: 3,
                        overflow: "hidden",
                      }}
                    >
                      {/* Item Header */}
                      <Box
                        sx={{
                          bgcolor: "#f8fafc",
                          p: 3,
                          borderBottom: "1px solid #e2e8f0",
                        }}
                      >
                        <Box display="flex" gap={3} alignItems="center">
                          {item.ImageUrl && (
                            <Box
                              component="img"
                              src={item.ImageUrl}
                              alt={item.Name}
                              sx={{
                                width: 80,
                                height: 80,
                                objectFit: "cover",
                                borderRadius: 1,
                                border: "1px solid #e2e8f0",
                              }}
                            />
                          )}
                          <Box flex={1}>
                            <Typography
                              variant="h6"
                              fontWeight="600"
                              color="#1e293b"
                              mb={1}
                            >
                              {item.Name}
                            </Typography>
                            <Typography variant="body2" color="#64748b">
                              {item.ShortDescription}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>

                      {/* Item Details */}
                      <Box sx={{ p: 3 }}>
                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns:
                              "repeat(auto-fit, minmax(200px, 1fr))",
                            gap: 3,
                            mb: 3,
                          }}
                        >
                          <Box>
                            <Typography
                              variant="body2"
                              color="#64748b"
                              mb={0.5}
                            >
                              Product ID
                            </Typography>
                            <Typography
                              variant="body1"
                              fontWeight="500"
                              color="#1e293b"
                              sx={{ fontFamily: "monospace" }}
                            >
                              {item.ProductId}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography
                              variant="body2"
                              color="#64748b"
                              mb={0.5}
                            >
                              Quantity
                            </Typography>
                            <Typography
                              variant="body1"
                              fontWeight="500"
                              color="#1e293b"
                            >
                              {item.Quantity}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography
                              variant="body2"
                              color="#64748b"
                              mb={0.5}
                            >
                              Color
                            </Typography>
                            <Typography
                              variant="body1"
                              fontWeight="500"
                              color="#1e293b"
                            >
                              {item.Color}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography
                              variant="body2"
                              color="#64748b"
                              mb={0.5}
                            >
                              Size
                            </Typography>
                            <Typography
                              variant="body1"
                              fontWeight="500"
                              color="#1e293b"
                            >
                              {item.Size}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography
                              variant="body2"
                              color="#64748b"
                              mb={0.5}
                            >
                              Source
                            </Typography>
                            <Typography
                              variant="body1"
                              fontWeight="500"
                              color="#1e293b"
                            >
                              {item.Source?.toUpperCase() || "N/A"}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography
                              variant="body2"
                              color="#64748b"
                              mb={0.5}
                            >
                              Supplier
                            </Typography>
                            <Typography
                              variant="body1"
                              fontWeight="500"
                              color="#1e293b"
                            >
                              {item.SupplierName}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography
                              variant="body2"
                              color="#64748b"
                              mb={0.5}
                            >
                              Subtotal
                            </Typography>
                            <Typography
                              variant="body1"
                              fontWeight="600"
                              color="#059669"
                            >
                              ${item.Subtotal} {item.CurrencyCode}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography
                              variant="body2"
                              color="#64748b"
                              mb={0.5}
                            >
                              Tax
                            </Typography>
                            <Typography
                              variant="body1"
                              fontWeight="500"
                              color="#1e293b"
                            >
                              $
                              {Number(
                                item.TaxAmount ??
                                  item.taxAmount ??
                                  item.Tax ??
                                  0
                              ).toFixed(2)}
                            </Typography>
                          </Box>
                        </Box>

                        {/* Full Description */}
                        {item.Description && (
                          <Box sx={{ mb: 3 }}>
                            <Typography variant="body2" color="#64748b" mb={1}>
                              Description
                            </Typography>
                            <Typography
                              variant="body2"
                              color="#475569"
                              sx={{ lineHeight: 1.6 }}
                            >
                              {item.Description}
                            </Typography>
                          </Box>
                        )}

                        {/* Decorations */}
                        {item.decorations && item.decorations.length > 0 && (
                          <Box>
                            <Typography
                              variant="subtitle1"
                              fontWeight="600"
                              color="#1e293b"
                              mb={2}
                            >
                              Decorations ({item.decorationCount ?? item.decorations.length}) | Charges ({item.chargeCount ?? item.decorations.reduce((sum, decoration) => sum + (decoration.Charge?.length || 0), 0)})
                            </Typography>

                            {item.decorations.map(
                              (decoration, decorationIndex) => (
                                <Box
                                  key={decoration.id}
                                  sx={{
                                    border: "1px solid #e2e8f0",
                                    borderRadius: 1,
                                    mb: 2,
                                    bgcolor: "#fafbfc",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      p: 2,
                                      borderBottom: "1px solid #e2e8f0",
                                      bgcolor: "#f1f5f9",
                                    }}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      fontWeight="600"
                                      color="#1e293b"
                                    >
                                      Decoration #{decorationIndex + 1}
                                    </Typography>
                                  </Box>

                                  <Box sx={{ p: 2 }}>
                                    <Box
                                      sx={{
                                        display: "grid",
                                        gridTemplateColumns:
                                          "repeat(auto-fit, minmax(200px, 1fr))",
                                        gap: 2,
                                        mb: 2,
                                      }}
                                    >
                                      <Box>
                                        <Typography
                                          variant="body2"
                                          color="#64748b"
                                          mb={0.5}
                                        >
                                          Location
                                        </Typography>
                                        <Typography
                                          variant="body1"
                                          fontWeight="500"
                                          color="#1e293b"
                                        >
                                          {decoration.Location}
                                        </Typography>
                                      </Box>
                                      <Box>
                                        <Typography
                                          variant="body2"
                                          color="#64748b"
                                          mb={0.5}
                                        >
                                          Method
                                        </Typography>
                                        <Typography
                                          variant="body1"
                                          fontWeight="500"
                                          color="#1e293b"
                                        >
                                          {decoration.DecoratorDetails
                                            ?.methodName || "N/A"}
                                        </Typography>
                                      </Box>
                                      <Box>
                                        <Typography
                                          variant="body2"
                                          color="#64748b"
                                          mb={0.5}
                                        >
                                          Source
                                        </Typography>
                                        <Typography
                                          variant="body1"
                                          fontWeight="500"
                                          color="#1e293b"
                                        >
                                          {decoration.DecoratorDetails
                                            ?.source || "N/A"}
                                        </Typography>
                                      </Box>
                                      <Box>
                                        <Typography
                                          variant="body2"
                                          color="#64748b"
                                          mb={0.5}
                                        >
                                          Decorator ID
                                        </Typography>
                                        <Typography
                                          variant="body1"
                                          fontWeight="500"
                                          color="#1e293b"
                                          sx={{ fontFamily: "monospace" }}
                                        >
                                          {decoration.DecoratorDetails
                                            ?.decoratorId || "N/A"}
                                        </Typography>
                                      </Box>
                                    </Box>

                                    {/* Charges */}
                                    {decoration.Charge &&
                                      decoration.Charge.length > 0 && (
                                        <Box>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#1e293b"
                                            mb={1}
                                          >
                                            Charges
                                          </Typography>
                                          {decoration.Charge.map(
                                            (charge, chargeIndex) => (
                                              <Box
                                                key={chargeIndex}
                                                sx={{
                                                  p: 2,
                                                  bgcolor: "white",
                                                  border: "1px solid #e2e8f0",
                                                  borderRadius: 1,
                                                  mb: 1,
                                                }}
                                              >
                                                <Box
                                                  sx={{
                                                    display: "grid",
                                                    gridTemplateColumns:
                                                      "repeat(auto-fit, minmax(150px, 1fr))",
                                                    gap: 2,
                                                  }}
                                                >
                                                  <Box>
                                                    <Typography
                                                      variant="body2"
                                                      color="#64748b"
                                                      mb={0.5}
                                                    >
                                                      Charge Name
                                                    </Typography>
                                                    <Typography
                                                      variant="body1"
                                                      fontWeight="600"
                                                      color="#1e293b"
                                                    >
                                                      {charge.Name}
                                                    </Typography>
                                                  </Box>
                                                  <Box>
                                                    <Typography
                                                      variant="body2"
                                                      color="#64748b"
                                                      mb={0.5}
                                                    >
                                                      Type
                                                    </Typography>
                                                    <Typography
                                                      variant="body1"
                                                      fontWeight="500"
                                                      color="#1e293b"
                                                    >
                                                      {charge.Type}
                                                    </Typography>
                                                  </Box>
                                                  <Box>
                                                    <Typography
                                                      variant="body2"
                                                      color="#64748b"
                                                      mb={0.5}
                                                    >
                                                      Total
                                                    </Typography>
                                                    <Typography
                                                      variant="body1"
                                                      fontWeight="600"
                                                      color="#059669"
                                                    >
                                                      ${charge.Total}
                                                    </Typography>
                                                  </Box>
                                                  <Box>
                                                    <Typography
                                                      variant="body2"
                                                      color="#64748b"
                                                      mb={0.5}
                                                    >
                                                      Retail
                                                    </Typography>
                                                    <Typography
                                                      variant="body1"
                                                      fontWeight="500"
                                                      color="#1e293b"
                                                    >
                                                      ${charge.Retail}
                                                    </Typography>
                                                  </Box>
                                                  <Box>
                                                    <Typography
                                                      variant="body2"
                                                      color="#64748b"
                                                      mb={0.5}
                                                    >
                                                      Net Cost
                                                    </Typography>
                                                    <Typography
                                                      variant="body1"
                                                      fontWeight="500"
                                                      color="#1e293b"
                                                    >
                                                      ${charge.NetCost}
                                                    </Typography>
                                                  </Box>
                                                  <Box>
                                                    <Typography
                                                      variant="body2"
                                                      color="#64748b"
                                                      mb={0.5}
                                                    >
                                                      Margin
                                                    </Typography>
                                                    <Typography
                                                      variant="body1"
                                                      fontWeight="500"
                                                      color="#1e293b"
                                                    >
                                                      ${charge.Margin}
                                                    </Typography>
                                                  </Box>
                                                  <Box>
                                                    <Typography
                                                      variant="body2"
                                                      color="#64748b"
                                                      mb={0.5}
                                                    >
                                                      Quantity
                                                    </Typography>
                                                    <Typography
                                                      variant="body1"
                                                      fontWeight="500"
                                                      color="#1e293b"
                                                    >
                                                      {charge.Quantity}
                                                    </Typography>
                                                  </Box>
                                                  <Box>
                                                    <Typography
                                                      variant="body2"
                                                      color="#64748b"
                                                      mb={0.5}
                                                    >
                                                      Client Price
                                                    </Typography>
                                                    <Typography
                                                      variant="body1"
                                                      fontWeight="500"
                                                      color="#1e293b"
                                                    >
                                                      ${charge.ClientPrice}
                                                    </Typography>
                                                  </Box>
                                                </Box>
                                              </Box>
                                            )
                                          )}
                                        </Box>
                                      )}
                                  </Box>
                                </Box>
                              )
                            )}
                          </Box>
                        )}
                      </Box>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          ) : (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              py={6}
            >
              <Typography variant="h6" color="#64748b" mb={1}>
                No order details available
              </Typography>
              <Typography variant="body2" color="#94a3b8">
                External Key: {modalCard.external_key}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions
          sx={{ p: 3, bgcolor: "#f8fafc", borderTop: "1px solid #e2e8f0" }}
        >
          <Button
            onClick={() => {
              setModalOpen(false);
              setModalCard(null);
              setOrderDetails(null);
            }}
            variant="contained"
            sx={{
              bgcolor: "#3b82f6",
              "&:hover": { bgcolor: "#2563eb" },
              borderRadius: 1.5,
              px: 4,
              textTransform: "none",
              fontWeight: 500,
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  // const [showFilters, setShowFilters] = useState(false);
  const [quickFilter, setQuickFilter] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [machineFilter, setMachineFilter] = useState("");
  const [dateRange, setDateRange] = useState({ start: "", end: "" });


  const filteredCards = useMemo(() => {
  let filtered = cards;

  // Text search
  if (searchInput) {
    const search = searchInput.toLowerCase();
    filtered = filtered.filter(card =>
      card.projectNumber?.toLowerCase().includes(search) ||
      card.projectName?.toLowerCase().includes(search) ||
      card.skuNumber?.toLowerCase().includes(search) ||
      card.department?.toLowerCase().includes(search) ||
      card.processName?.toLowerCase().includes(search)
    );
  }

  // Status filter
  if (quickFilter) {
    filtered = filtered.filter(card => card.orderProductionState === quickFilter);
  }

  // Process filter
  if (machineFilter) {
    filtered = filtered.filter(card => card.processName === machineFilter);
  }

  // Date range filter (you'll need to add date fields to your data)
  if (dateRange.start) {
    filtered = filtered.filter(card => {
      // Add your date comparison logic here
      return true; // placeholder
    });
  }

  return filtered;
}, [cards, searchInput, quickFilter, machineFilter, dateRange]);

  return (
    <div
      style={{
        border: "1px solid #ddd",
        padding: "10px",
        borderRadius: "6px",
        width: "100%",
        height: "700px",
        overflowX: "auto",
        overflowY: "auto",
      }}
    >
      {/* Search Input */}
      {/* <div style={{ marginBottom: "10px" }}>
        <input
          type="text"
          placeholder="Search by order number, product, SKU, or department..."
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          style={{
            width: "300px",
            padding: "8px",
            border: "1px solid #ccc",
            borderRadius: "4px",
          }}
        />
        <span style={{ marginLeft: "10px", color: "#666" }}>
          {department ? `Department: ${department}` : "All Departments"} 
          ({filteredCards.length} items)
        </span>
      </div> */}


      <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm mb-4">
        <div className="flex items-center justify-between px-6 h-16">
          {/* Left: Title + Stats */}
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-3">
              <h1 className="text-lg font-semibold text-gray-900">
                Production Table
                {department && (
                  <span className="ml-2 text-base font-normal text-gray-600">
                    • {department.charAt(0).toUpperCase() + department.slice(1)}
                  </span>
                )}
              </h1>

              {/* Loading Indicator */}
              {loading && (
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
                  <span className="text-sm text-blue-600 font-medium">
                    Loading...
                  </span>
                </div>
              )}
            </div>

            {/* Stats Pills */}
            <div className="flex items-center space-x-2">
              <div className="px-3 py-1 bg-slate-100 text-slate-700 text-sm rounded-full font-medium">
                {filteredCards.length}{" "}
                {filteredCards.length === 1 ? "Item" : "Items"}
              </div>

              {department && (
                <div className="px-3 py-1 bg-blue-50 text-blue-700 text-sm rounded-full font-medium">
                  {department}
                </div>
              )}

              {/* Show filtered count if searching */}
              {searchInput && filteredCards.length !== cards.length && (
                <div className="px-3 py-1 bg-amber-50 text-amber-700 text-sm rounded-full font-medium">
                  {cards.length - filteredCards.length} Hidden
                </div>
              )}
            </div>
          </div>

          {/* Right: Search & Filters */}
          <div className="flex items-center space-x-3">
            {/* Search Input */}
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg
                  className="h-4 w-4 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                type="text"
                placeholder="Search orders, products, SKUs..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                className="block w-80 pl-10 pr-4 py-2.5 text-sm text-gray-900 bg-gray-50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-200"
              />
              {searchInput && (
                <button
                  onClick={() => setSearchInput("")}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                >
                  <svg
                    className="h-4 w-4 text-gray-400 hover:text-gray-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              )}
            </div>

            {/* Status Filter */}
            <select
              value={quickFilter}
              onChange={(e) => setQuickFilter(e.target.value)}
              className="px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-200 cursor-pointer"
            >
              <option value="">All Status</option>
              <option value="Planned">Planned</option>
              <option value="Scheduled">Scheduled</option>
              <option value="InProduction">In Production</option>
              <option value="QC">QC</option>
              <option value="Completed">Completed</option>
              <option value="OnHold">On Hold</option>
            </select>

            {/* Process Filter */}
            <select
              value={machineFilter}
              onChange={(e) => setMachineFilter(e.target.value)}
              className="px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-200 cursor-pointer"
            >
              <option value="">All Processes</option>
              {Array.from(
                new Set(cards.map((card) => card.processName).filter(Boolean))
              ).map((process) => (
                <option key={process} value={process}>
                  {process}
                </option>
              ))}
            </select>

            {/* More Filters Button */}
            <button
              onClick={() => setShowFilters(!showFilters)}
              className={`relative p-2.5 rounded-xl font-medium transition-all duration-200 ${
                showFilters
                  ? "bg-blue-100 text-blue-700 shadow-sm"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }`}
              title="More filters"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4"
                />
              </svg>

              {/* Active Filter Indicator */}
              {(quickFilter ||
                machineFilter ||
                dateRange.start ||
                dateRange.end) && (
                <div className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"></div>
              )}
            </button>

            {/* Clear All Filters */}
            {(searchInput ||
              quickFilter ||
              machineFilter ||
              dateRange.start ||
              dateRange.end) && (
              <button
                onClick={() => {
                  setSearchInput("");
                  setQuickFilter("");
                  setMachineFilter("");
                  setDateRange({ start: "", end: "" });
                }}
                className="px-4 py-2.5 text-sm font-medium text-red-600 bg-red-50 hover:bg-red-100 rounded-xl transition-all duration-200"
              >
                Clear All
              </button>
            )}

            {/* Export Button */}
            <button
              onClick={() => {
                // Add export functionality
                const csvContent = filteredCards
                  .map(
                    (card) =>
                      `${card.projectNumber},${card.projectName},${card.skuNumber},${card.processName},${card.qtyRequired},${card.orderProductionState}`
                  )
                  .join("\n");
                const blob = new Blob([csvContent], { type: "text/csv" });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `production-table-${department || "all"}.csv`;
                a.click();
              }}
              className="p-2.5 text-gray-500 hover:text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-xl transition-all duration-200"
              title="Export to CSV"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Expandable Advanced Filters */}
        {showFilters && (
          <div className="border-t border-gray-100 bg-gradient-to-r from-gray-50 to-white">
            <div className="px-6 py-4">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-2">
                  <svg
                    className="w-4 h-4 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4"
                    />
                  </svg>
                  <span className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                    Advanced Filters
                  </span>
                </div>

                <button
                  onClick={() => setShowFilters(false)}
                  className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {/* SKU Filter */}
                <div className="space-y-2">
                  <label className="block text-xs font-medium text-gray-600 uppercase tracking-wide">
                    SKU Contains
                  </label>
                  <input
                    type="text"
                    placeholder="Enter SKU..."
                    className="w-full px-3 py-2 text-sm bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                  />
                </div>

                {/* Quantity Range */}
                <div className="space-y-2">
                  <label className="block text-xs font-medium text-gray-600 uppercase tracking-wide">
                    Min Quantity
                  </label>
                  <input
                    type="number"
                    placeholder="0"
                    className="w-full px-3 py-2 text-sm bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                  />
                </div>

                {/* Date From */}
                <div className="space-y-2">
                  <label className="block text-xs font-medium text-gray-600 uppercase tracking-wide">
                    From Date
                  </label>
                  <input
                    type="date"
                    value={dateRange.start}
                    onChange={(e) =>
                      setDateRange((prev) => ({
                        ...prev,
                        start: e.target.value,
                      }))
                    }
                    className="w-full px-3 py-2 text-sm bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                  />
                </div>

                {/* Date To */}
                <div className="space-y-2">
                  <label className="block text-xs font-medium text-gray-600 uppercase tracking-wide">
                    To Date
                  </label>
                  <input
                    type="date"
                    value={dateRange.end}
                    onChange={(e) =>
                      setDateRange((prev) => ({ ...prev, end: e.target.value }))
                    }
                    className="w-full px-3 py-2 text-sm bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </header>

      {loading ? (
        <div>Loading production cards...</div>
      ) : (
        <div style={{ minWidth: `${totalColumnWidth}px` }}>
          <DataTable
            columns={columns}
            rows={filteredCards}
            className="production-table"
            getRowId={(row) => row.id}
            minHeight={500} // ✅ Set to 700px or higher
            // autoHeight
            //      onRowClick={(params, event) => {
            //   // Check if click was on action button
            //   if (event.target.tagName === 'BUTTON') return;
            //   openCard(params.row);
            // }}

            onRowClick={(params, event) => {
              // Check if click was on action button
              if (event.target.tagName === "BUTTON") return;
              console.log("Row clicked:", params.row); //  Debug log
              openCard(params.row);
            }}
            sx={{
              "& .MuiDataGrid-row": {
                cursor: "pointer",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#f3f4f6",
              },
              // Override the global CSS for this specific table
              '& .MuiDataGrid-cell[data-field="projectNumber"], & .MuiDataGrid-columnHeader[data-field="projectNumber"]': {
                width: "100px !important",
                minWidth: "100px !important",
                maxWidth: "100px !important",
              },
              '& .MuiDataGrid-cell[data-field="projectName"], & .MuiDataGrid-columnHeader[data-field="projectName"]': {
                width: "200px !important",
                minWidth: "200px !important",
                maxWidth: "200px !important",
              },
              '& .MuiDataGrid-cell[data-field="skuNumber"], & .MuiDataGrid-columnHeader[data-field="skuNumber"]': {
                width: "150px !important",
                minWidth: "150px !important",
                maxWidth: "150px !important",
              },
              '& .MuiDataGrid-cell[data-field="processName"], & .MuiDataGrid-columnHeader[data-field="processName"]': {
                width: "150px !important",
                minWidth: "150px !important",
                maxWidth: "150px !important",
              },
              '& .MuiDataGrid-cell[data-field="qtyRequired"], & .MuiDataGrid-columnHeader[data-field="qtyRequired"]': {
                width: "100px !important",
                minWidth: "100px !important",
                maxWidth: "100px !important",
              },
              '& .MuiDataGrid-cell[data-field="orderProductionState"], & .MuiDataGrid-columnHeader[data-field="orderProductionState"]': {
                width: "130px !important",
                minWidth: "130px !important",
                maxWidth: "130px !important",
              },
              '& .MuiDataGrid-cell[data-field="orderStatus"], & .MuiDataGrid-columnHeader[data-field="orderStatus"]': {
                width: "180px !important",
                minWidth: "180px !important",
                maxWidth: "180px !important",
              },
            }}
          />
        </div>
      )}
      <OrderDetailsModal />
    </div>
  );
};

export default ProductionTable;
